import { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  Link,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/authSlice";
import { showSnackbar } from "../../store/snackbarSlice";
import { useNavigate } from "react-router-dom";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { loginUser } from "../../api/api";

import "./login.css";

const Login = () => {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 🔥 HANDLE CHANGE
  const handleChange = (key: string, value: string) => {
    setForm((prev) => ({
      ...prev,
      [key]: key === "email" ? value.trim().toLowerCase() : value,
    }));

    setErrors((prev: any) => ({ ...prev, [key]: "" }));
  };

  // 🔥 VALIDATION
  const validate = () => {
    const newErrors: any = {};

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!form.password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔥 LOGIN
  const handleLogin = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const res = await loginUser(form);
      console.log(res);
      const { token, user } = res.data;

      dispatch(loginSuccess({ token, user }));

      dispatch(
        showSnackbar({
          message: "Login successful 🎉",
          type: "success",
        }),
      );

      navigate("/dashboard");
    } catch (err: any) {
      console.log(err);
      dispatch(
        showSnackbar({
          message: err?.message || err?.response?.data?.msg || "Login Failed",
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-container">
      <Paper elevation={0} className="login-card">
        {/* TITLE */}
        <Typography variant="h5" className="login-title">
          Welcome Back 👋
        </Typography>

        <Typography className="login-subtitle">
          Login to your DSA Panel
        </Typography>

        {/* EMAIL */}
        <TextField
          placeholder="Email Address"
          fullWidth
          size="small"
          className="login-input"
          value={form.email}
          error={!!errors.email}
          helperText={errors.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />

        {/* PASSWORD */}
        <TextField
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          size="small"
          className="login-input"
          value={form.password}
          error={!!errors.password}
          helperText={errors.password}
          onChange={(e) => handleChange("password", e.target.value)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    size="small"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />

        {/* BUTTON */}
        <Button
          fullWidth
          className="login-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Login"}
        </Button>

        {/* LINKS */}
        <Box className="login-links">
          <Typography
            className="login-link"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </Typography>

          <Typography
            className="login-link"
            onClick={() => navigate("/register")}
          >
            Create Account
          </Typography>
        </Box>

        {/* FOOTER */}
        <Box className="login-footer">
  {/* 🔥 LOGO */}
  <img
    src="/ssquare-logo.png"
    alt="SSQUARE LOGIC"
    className="footer-logo"
  />

  {/* 🔥 TEXT */}
  <Typography className="footer-text">
    Powered by{" "}
    <Link
      href="https://ssquarelogic.com/"
      target="_blank"
      underline="none"
      className="footer-brand"
    >
      SSQUARE LOGIC
    </Link>
  </Typography>
</Box>
      </Paper>
    </Box>
  );
};

export default Login;
